import * as angular from 'angular';
import * as _ from 'lodash';

import {
    ContextualField,
    IValueViewModel,
    Identifier,
    ObjectType,
} from '../../../../models/index';

import { correspondenceTableProperties } from './correspondanceTreeProperties';
import { getCommonProperties } from './commonProperties';
import { tagDefinitionGuidProperty } from './tagDefinitionGuidProperty';
import { targetProperty } from './targetProperty';

const measuredProperties: ContextualField[] =
    getCommonProperties()
        .concat(
            [
                // Tag
                angular.copy(tagDefinitionGuidProperty),
                angular.copy(targetProperty)
            ]
        )
        .concat(correspondenceTableProperties);


export function getMeasuredProperties(selectedItem: Identifier) {
    const properties = measuredProperties;
    const tagDefinitionGuid = _.find(properties, p => p.modelName === 'tagDefinitionGuid');
    if (tagDefinitionGuid) {
        // dynamically set to filter according to variable type list
        tagDefinitionGuid.extraData.filter = (list: IValueViewModel[]) => {
            return list.filter(l => l.objectType === ObjectType.Tag);
        };
    }
    return properties;
}